




























































































import Vue from 'vue';
import Component from 'vue-class-component';
import { Prop } from 'vue-property-decorator';
import ClientOnly from 'vue-client-only';
import { IMapLabel, IMapPoi, IMapPoiCluster } from '@frontend/types/modules/IMaps';
import GoogleMapsUtil from '@frontend/utils/GoogleMapsUtil';
import ButtonComponent from '@components/004-ButtonComponent/ButtonComponent.vue';
import IconButton from '@components/002-IconButton/IconButton.vue';
import IconTextLink from '@components/005-IconTextLink/IconTextLink.vue';
import BaseSlider, { IBaseSliderOptions } from '@components/base/BaseSlider';
import ILink from '@frontend/types/base/ILink';
import DirectionsSVG from '@assets/svg/map-directions.svg';
import PhoneSVG from '@assets/svg/map-phone.svg';
import PinSVG from '@assets/svg/map-pin.svg';
import StarRating from 'vue-star-rating';
import { mq } from '@frontend/utils/MediaQueriesUtil';
import AnchorNavigationUtil from '@frontend/utils/AnchorNavigationUtil';
import UserConsentUtil from '@frontend/utils/UserConsentUtil';
import MapsIntro from './components/MapsIntro.vue';

import GoogleMap = google.maps.Map;
import Marker = google.maps.Marker;
import LatLngBounds = google.maps.LatLngBounds;
import MarkerOptions = google.maps.MarkerOptions;

@Component({
	hydration: true,
	componentId: 'M016',
	components: {
		ClientOnly,
		MapsIntro,
		ButtonComponent,
		IconTextLink,
		IconButton,
		DirectionsSVG,
		PhoneSVG,
		PinSVG,
		StarRating
	}
})
export default class Maps extends Vue {
	@Prop(String)
	protected readonly type!: 'job' | 'tourstop' | 'store' | 'sfjob';

	@Prop(String)
	protected readonly headline!: string;

	@Prop(Number)
	protected readonly headlineLevel?: number;

	@Prop(String)
	protected readonly name?: string;

	@Prop(Number)
	protected readonly availableJobs?: number;

	@Prop(String)
	protected readonly svgMap!: string;

	@Prop(Array)
	protected readonly list!: IMapPoiCluster[];

	@Prop(String)
	protected readonly primaryBackgroundColor?: string;

	@Prop(String)
	protected readonly mapColor?: string;

	@Prop(Object)
	protected readonly link?: ILink;

	protected baseSliderPromise?: any;

	protected BaseSlider?: any;

	protected boxSlider?: BaseSlider;

	protected googleMap!: GoogleMap;

	protected googleMapOpened = false;

	protected currentSelectedCluster?: IMapPoiCluster | null = null;

	protected currentSelectedPoi?: IMapPoi | null = null;

	protected markers: MarkerWithId[] = [];

	protected mounted(): void {
		this.baseSliderPromise = this.loadBaseSlider();
	}

	protected async loadBaseSlider(): Promise<void> {
		this.BaseSlider = (await import('@components/base/BaseSlider')).default;
	}

	protected get pinLabels(): IMapLabel[] {
		return this.list.map(item => {
			const count = this.type === 'job' || this.type === 'sfjob' ? item.availableJobs : item.poiList.length;
			return {
				id: item.id,
				svgId: item.svgId,
				text: `${count}x`,
				arialabel: this.ariaLabelForPin(item)
			};
		});
	}

	protected get currentZoomLevelData(): IMapPoi | IMapPoiCluster | any {
		if (this.currentSelectedPoi) {
			return this.currentSelectedPoi;
		}
		if (this.currentSelectedCluster) {
			return this.currentSelectedCluster;
		}
		return this;
	}

	protected ariaLabelForPin(item: IMapPoiCluster): string {
		const count = this.type === 'job' || this.type === 'sfjob' ? item.availableJobs : item.poiList.length;

		if ((this.type === 'job' || this.type === 'sfjob') && count) {
			const text = count && count > 1 ? this.i18n.mapVacancyTextPlural : this.i18n.mapVacancyTextSingular;
			return text.replace('{count}', `${count}`).replace('{location}', `${item.name}`);
		}
		if (this.type === 'store' && count) {
			const text = count && count > 1 ? this.i18n.mapShopTextPlural : this.i18n.mapShopTextSingular;
			return text.replace('{count}', `${count}`).replace('{location}', `${item.name}`);
		}
		return '';
	}

	protected get introCopy(): string | null {
		const count = this.availableJobs;

		if ((this.type === 'job' || this.type === 'sfjob') && count) {
			const text = count && count > 1 ? this.i18n.mapVacancyTextPlural : this.i18n.mapVacancyTextSingular;
			return text.replace('{count}', `<span>${count}</span>`).replace('{location}', `<span>${this.name}</span>`);
		}
		return null;
	}

	protected get infoBoxCopy(): string | null {
		if (this.type === 'job' || this.type === 'sfjob') {
			const location = this.currentZoomLevelData.name;
			const count = this.currentZoomLevelData.availableJobs;

			const text = count && count > 1 ? this.i18n.mapVacancyTextPlural : this.i18n.mapVacancyTextSingular;

			if (location && count) {
				return text.replace('{count}', `<span>${count}</span>`).replace('{location}', `<span>${location}</span>`);
			}
			return null;
		}
		return null;
	}

	protected get introPageLink(): string {
		let type = '';

		if (this.type === 'job' || this.type === 'sfjob') {
			type = this.availableJobs && this.availableJobs > 1 ? this.i18n.jobPlural : this.i18n.jobSingular;
		}

		if (this.type === 'tourstop') {
			type = this.fullPoiList.length > 1 ? this.i18n.tourstopPlural : this.i18n.tourstopSingular;
		}

		if (this.type === 'store') {
			type = this.fullPoiList.length > 1 ? this.i18n.storePlural : this.i18n.storeSingular;
		}

		return this.i18n.mapDetailLinkLabel.replace('{type}', type);
	}

	protected get detailPageLink(): string {
		let type = '';

		if (this.type === 'job' || this.type === 'sfjob') {
			const numJobs = this.currentZoomLevelData.availableJobs;
			type = numJobs && numJobs > 1 ? this.i18n.jobPlural : this.i18n.jobSingular;
		}

		if (this.currentSelectedPoi) {
			if (this.type === 'tourstop') type = this.i18n.tourstopSingular;
			if (this.type === 'store') type = this.i18n.storeSingular;
		}

		return this.i18n.mapDetailLinkLabel.replace('{type}', type);
	}

	protected get detailLink(): ILink | null {
		if (this.currentSelectedPoi && this.currentSelectedPoi.link) {
			return this.currentSelectedPoi.link;
		}

		if (this.currentSelectedCluster && this.currentSelectedCluster.link) {
			return this.currentSelectedCluster.link;
		}

		return null;
	}

	protected get fullPoiList(): IMapPoi[] {
		const locations: IMapPoi[] = [];

		this.list.forEach(cluster => {
			cluster.poiList.forEach(poi => {
				locations.push(poi);
			});
		});

		return locations;
	}

	protected get hasActiveDetailPoi(): boolean {
		return !!this.currentSelectedPoi;
	}

	protected async showOnMap(id: string): Promise<void> {
		if (!UserConsentUtil.marketingConsent) {
			const warning = document.createElement('div');
			warning.classList.add('m-maps__warning');
			warning.classList.add('fs-copy-a3');
			warning.innerHTML = this.i18n.acceptMarketingCookiesForMap;
			const mapelement = document.getElementsByClassName('m-maps__intro');
			mapelement[0].appendChild(warning);
			UserConsentUtil.requestConsent();
			window.addEventListener(
				'CookiebotOnAccept',
				function reloadPageAfterCookiebot(): void {
					if (UserConsentUtil.marketingConsent) {
						window.location.reload();
					}
				},
				false
			);
			warning.addEventListener('click', function showCookiebotAgain() {
				UserConsentUtil.requestConsent();
				return false;
			});
			return;
		}
		await GoogleMapsUtil.initApi();

		if (!this.googleMap) {
			this.initGoogleMap();
			this.addMarkers();
		}

		await this.$nextTick();

		if (!this.boxSlider) {
			await this.initBoxSlider();
		}

		this.zoomToPoiCluster(id);
		this.showGoogleMap();
	}

	protected initGoogleMap(): void {
		const wrapper = this.$refs.googleMap as HTMLElement;
		this.googleMap = new google.maps.Map(wrapper, {
			center: this.getBoundsForPoiList(this.fullPoiList).getCenter(),
			streetViewControl: false,
			mapTypeControl: false,
			rotateControl: false,
			fullscreenControl: false
		});

		const self = this;

		// https://developers.google.com/maps/documentation/javascript/examples/overlay-simple
		class LabelOverlay extends google.maps.OverlayView {
			private readonly poiList: any[];

			constructor(poiList: IMapPoi[]) {
				super();

				this.poiList = poiList;
			}

			onAdd() {
				const overlayLayer = this.getPanes().overlayMouseTarget as HTMLElement;
				overlayLayer.style.zIndex = '1001';

				this.poiList.forEach((poi): void => {
					if (!poi.availableJobs) return;

					const labelPosition = poi.customLabelPosition || 'right';

					const div = document.createElement('div');
					div.innerHTML = `${poi.availableJobs} ${poi.availableJobs > 1 ? self.i18n.jobPlural : self.i18n.jobSingular}`;
					div.classList.add('m-map__custom-label', `m-map__custom-label--${labelPosition}`);
					div.setAttribute('data-pin-label', poi.id);

					div.addEventListener('click', () => {
						self.zoomToSinglePoi(poi.id);
					});

					overlayLayer.appendChild(div);
				});
			}

			draw() {
				const overlayProjection = this.getProjection();

				this.poiList.forEach((poi): void => {
					const element: HTMLElement | null = document.querySelector(`[data-pin-label="${poi.id}"]`);
					if (element) {
						const point = overlayProjection.fromLatLngToDivPixel(new google.maps.LatLng(poi.location));
						element.style.left = `${point.x}px`;
						element.style.top = `${point.y}px`;
					}
				});
			}
		}

		const overlay = new LabelOverlay(this.fullPoiList);
		overlay.setMap(this.googleMap);
	}

	protected addMarkers(): void {
		this.fullPoiList.forEach(poi => {
			const markerOptions: MarkerOptionsWithId = {
				map: this.googleMap,
				position: poi.location,
				id: poi.id,
				title: `marker-${poi.id}`
			};

			const marker: MarkerWithId = new google.maps.Marker(markerOptions);

			marker.addListener('click', () => {
				this.zoomToSinglePoi(poi.id);
			});

			this.markers.push(marker);
		});
	}

	protected resetMarkerOpacity(): void {
		this.markers.forEach(marker => {
			marker.setOpacity(1);
		});
	}

	protected showShopDetail(event: MouseEvent, url: string): void {
		const hash = url.split('#')[1];

		if (hash && hash !== 'jobs') {
			event.preventDefault();
			AnchorNavigationUtil.goToAnchor(`#${hash}`);
		}
	}

	protected zoomToSinglePoi(id: string): void {
		const poi = this.getPoiPerId(id);

		this.googleMap.setZoom(13);
		this.googleMap.panTo(poi.location);

		if (mq.S.matches) {
			this.googleMap.panBy(0, 130);
		}

		if (mq.M.matches) {
			this.googleMap.panBy(0, -80);
		}

		this.currentSelectedPoi = poi;

		this.markers.forEach(marker => {
			if (marker.id === poi.id) {
				marker.setOpacity(1);
			} else {
				marker.setOpacity(0.6);
			}
		});

		this.gotoBoxSlide(poi.id);
	}

	protected zoomToAllPoi(): void {
		const bounds = this.getBoundsForPoiList(this.fullPoiList);
		this.googleMap.fitBounds(bounds);
	}

	protected zoomToPoiCluster(id: string): void {
		const latLngZoom = this.getCenterAndZoomForRegion(id);
		if ((this.type === 'job' || this.type === 'sfjob') && latLngZoom.zoom > 0) {
			this.googleMap.setCenter({ lat: latLngZoom.lat, lng: latLngZoom.lng });
			this.googleMap.setZoom(latLngZoom.zoom);
		} else {
			const bounds = this.getBoundsForPoiList(this.getPoiListForProvince(id));
			this.googleMap.fitBounds(bounds);
		}
		setTimeout(() => {
			if (this.googleMap.getZoom() > 12) {
				this.googleMap.setZoom(12);
			} else {
				this.googleMap.setZoom(this.googleMap.getZoom() - 1);
			}
		}, 100);
		this.currentSelectedCluster = this.getClusterPerId(id);
	}

	protected getClusterPerId(id: string): IMapPoiCluster {
		return this.list.find(item => item.id === id) as IMapPoiCluster;
	}

	protected getPoiPerId(id: string): IMapPoi {
		return this.fullPoiList.find(item => item.id === id) as IMapPoi;
	}

	protected getPoiListForProvince(id: string): IMapPoi[] {
		return this.getClusterPerId(id).poiList;
	}

	protected getBoundsForPoiList(poiList: IMapPoi[]): LatLngBounds {
		const bounds: LatLngBounds = new google.maps.LatLngBounds();

		poiList.forEach((poi): void => {
			if (poi.location) {
				bounds.extend(poi.location);
			}
		});

		return bounds;
	}

	protected showGoogleMap(): void {
		this.googleMapOpened = true;
	}

	protected hideGoogleMap(): void {
		this.googleMapOpened = false;

		setTimeout(() => {
			this.currentSelectedCluster = null;
			this.currentSelectedPoi = null;
			this.zoomToAllPoi();
			this.resetMarkerOpacity();
		}, 800);
	}

	private async initBoxSlider(): Promise<void> {
		const boxSliderOptions: IBaseSliderOptions = {
			flickityOptions: {
				pageDots: false,
				adaptiveHeight: true
			}
		};

		await this.baseSliderPromise;
		this.boxSlider = new this.BaseSlider(this.$refs.info as HTMLElement, boxSliderOptions);

		if (this.boxSlider && this.boxSlider.flickity) {
			this.boxSlider.flickity.on('change' as any, (slideNum: any): void => {
				const poi = this.fullPoiList[slideNum];
				this.zoomToSinglePoi(poi.id);
			});
		}
	}

	protected gotoBoxSlide(id: string): void {
		if (this.boxSlider && this.boxSlider.flickity) {
			this.boxSlider.flickity.selectCell(`[data-id=${id}`);
		}
	}

	/**
	 *
	 * @param id
	 * @protected
	 */
	protected getCenterAndZoomForRegion(id: string): { lat: number; lng: number; zoom: number } {
		let regiondata = { lat: 0, lng: 0, zoom: 0 };
		switch (id) {
			case 'baden-wuerttemberg': {
				regiondata = { lat: 48.53775, lng: 9.041169, zoom: 9 };
				break;
			}
			case 'bayern': {
				regiondata = { lat: 48.946756, lng: 11.403872, zoom: 9 };
				break;
			}
			case 'berlin': {
				regiondata = { lat: 52.510885, lng: 13.398937, zoom: 10 };
				break;
			}
			case 'brandenburg': {
				regiondata = { lat: 52.845549, lng: 13.24613, zoom: 9 };
				break;
			}
			case 'bremen': {
				regiondata = { lat: 53.07582, lng: 8.807165, zoom: 10 };
				break;
			}
			case 'hamburg': {
				regiondata = { lat: 53.5586622, lng: 9.7626731, zoom: 10 };
				break;
			}
			case 'hessen': {
				regiondata = { lat: 50.608065, lng: 9.028465, zoom: 9 };
				break;
			}
			case 'mecklenburg-vorpommern': {
				regiondata = { lat: 53.773514, lng: 12.575557, zoom: 9 };
				break;
			}
			case 'niedersachsen': {
				regiondata = { lat: 52.839853, lng: 9.075962, zoom: 9 };
				break;
			}
			case 'nordrhein-westfalen': {
				regiondata = { lat: 51.42704, lng: 7.580398, zoom: 9 };
				break;
			}
			case 'rheinland-pfalz': {
				regiondata = { lat: 49.9545302, lng: 7.3103268, zoom: 9 };
				break;
			}
			case 'saarland': {
				regiondata = { lat: 49.384187, lng: 6.953737, zoom: 10 };
				break;
			}
			case 'sachsen': {
				regiondata = { lat: 50.92958, lng: 13.458505, zoom: 9 };
				break;
			}
			case 'sachsen-anhalt': {
				regiondata = { lat: 52.008907, lng: 11.700334, zoom: 9 };
				break;
			}
			case 'schleswig-holstein': {
				regiondata = { lat: 54.1854, lng: 9.822009, zoom: 9 };
				break;
			}
			case 'thueringen': {
				regiondata = { lat: 50.901472, lng: 11.037784, zoom: 9 };
				break;
			}
			default: {
				regiondata = { lat: 0, lng: 0, zoom: 0 };
			}
		}
		return regiondata;
	}
}

interface MarkerOptionsWithId extends MarkerOptions {
	id?: string;
}

interface MarkerWithId extends Marker {
	id?: string;
}
